var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPhotoAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 10H35.66L32 6H20V10H30.24L33.9 14H42V38H10V20H6V38C6 40.2 7.8 42 10 42H42C44.2 42 46 40.2 46 38V14C46 11.8 44.2 10 42 10ZM16 26C16 31.52 20.48 36 26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16C20.48 16 16 20.48 16 26ZM26 20C29.3 20 32 22.7 32 26C32 29.3 29.3 32 26 32C22.7 32 20 29.3 20 26C20 22.7 22.7 20 26 20ZM10 10H16V6H10V0H6V6H0V10H6V16H10V10Z",
    fill: "#B2B2B2"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhotoAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/photo_add.42b16b8b.svg";
export { ForwardRef as ReactComponent };